import GUI from "lil-gui";

class debuggerUI extends GUI {
  constructor(ctx) {
    super();
    this.ctx = ctx;
    this.renderer = ctx.renderer;
    this.isDevEnv = ctx.isDevEnv;
    this.isTouchDevice = ctx.isTouchDevice;

    this.debugProperties = {
      geometries: this.renderer.glRenderer.info.memory.geometries,
      textures: this.renderer.glRenderer.info.memory.textures,
      drawCall: this.renderer.glRenderer.info.render.calls,
      triangles: this.renderer.glRenderer.info.render.triangles,
      lines: this.renderer.glRenderer.info.render.lines,
      points: this.renderer.glRenderer.info.render.points,
    };

    this.testFunctionalities = {
      dynamicJoystick: false,
      fpsControls: false,
      objectObstruction: -1,
    };
  }

  init() {
    const debugFolder = this.addFolder("Debug Properties");
    debugFolder.add(this.debugProperties, "geometries").listen();
    debugFolder.add(this.debugProperties, "textures").listen();
    debugFolder.add(this.debugProperties, "drawCall").listen();
    debugFolder.add(this.debugProperties, "triangles").listen();
    debugFolder.add(this.debugProperties, "lines").listen();
    debugFolder.add(this.debugProperties, "points").listen();

    if (this.isDevEnv) {
      const testFolder = this.addFolder("Test Functionalities");
      const dynamicJoystick = testFolder
        .add(this.testFunctionalities, "dynamicJoystick")
        .onChange(this.onChange.dynamicJoystick);
      const fpsControls = testFolder
        .add(this.testFunctionalities, "fpsControls")
        .onChange(this.onChange.fpsControls);
      const objectObstruction = testFolder
        .add(this.testFunctionalities, "objectObstruction")
        .options({
          None: -1,
          "Object Fading": 0,
          "Camera Colliding": 1,
          "Avatar Silhouette": 2,
          "Avatar Outline": 3,
        })
        .onChange(this.onChange.objectObstruction);

      if (this.isTouchDevice) fpsControls.disable();
      else dynamicJoystick.disable();
    }

    if (this.isTouchDevice && this.isDevEnv) this.close();
    else this.hide();
  }

  update() {
    this.debugProperties.geometries =
      this.renderer.glRenderer.info.memory.geometries;
    this.debugProperties.textures =
      this.renderer.glRenderer.info.memory.textures;
    this.debugProperties.drawCall = this.renderer.glRenderer.info.render.calls;
    this.debugProperties.triangles =
      this.renderer.glRenderer.info.render.triangles;
    this.debugProperties.lines = this.renderer.glRenderer.info.render.lines;
    this.debugProperties.points = this.renderer.glRenderer.info.render.points;
  }

  onChange = {
    dynamicJoystick: value => {
      this.ctx.joystick.isDynamic = value;
      this.ctx.removeJoystick(!value);
      this.ctx.addJoystick(value);
    },
    fpsControls: value => {
      if (value === true) this.ctx.changeShootingMode("FPS_MODE");
      else this.ctx.changeShootingMode("NORMAL_MODE");
    },
    objectObstruction: value => {
      switch (this.prevObjectObstructionOption) {
        case 0:
          this.ctx.unapplyShader([
            ...new Set(this.ctx.playCamIntersects.map(i => i.object)),
          ]);
          break;
        case 1:
          if (this.ctx.camDistance) {
            this.ctx.rayDirV3 = this.ctx.playCamera.position
              .clone()
              .sub(this.ctx.rayOriginV3);
            this.ctx.playCamera.position.addVectors(
              this.ctx.rayOriginV3,
              this.ctx.rayDirV3.setLength(this.ctx.camDistance),
            );
            this.ctx.camDistance = 0;
          }
          break;
        case 2:
          this.ctx.avatarSilhouette.traverse(child => (child.visible = false));
          break;
        case 3:
          this.ctx.renderer.activateOutline(false);
          break;
        default:
          break;
      }
      switch (value) {
        case 0:
          this.ctx.applyShader([
            ...new Set(this.ctx.playCamIntersects.map(i => i.object)),
          ]);
          break;
        case 2:
          if (this.ctx.avatarSilhouette)
            this.ctx.avatarSilhouette.traverse(child => (child.visible = true));
          break;
        default:
          break;
      }
      this.ctx.objectObstructionOptions[
        this.prevObjectObstructionOption
      ] = false;
      this.ctx.objectObstructionOptions[value] = true;
      this.prevObjectObstructionOption = value;
    },
  };
}

export default debuggerUI;
